import React, { useState } from "react";
import Toolbar from "../../toolbar/Toolbar";
import "./MainSlider.css";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { BiSearch } from "react-icons/bi";
import background1 from "../../../assets/clicksliderImages/slider.jpeg";
import background2 from "../../../assets/clicksliderImages/slider2.jpeg";
import background3 from "../../../assets/clicksliderImages/slider-3.jpg";
import background4 from "../../../assets/clicksliderImages/slider-4.jpg";
import background5 from "../../../assets/clicksliderImages/slider-5.jpg";

export default function MainSlider() {
  const [count, setChange] = useState(0);
  function next() {
    setChange(count + 1);
    if (count > 1) {
      setChange(0);
    }
  }
  function previous() {
    setChange(count - 1);
    if (count < 1) {
      setChange(2);
    }
  }
  const array = [
    {
      Heading: "BOMSIE VISIT",
      Title: "One Window Operations",
      Discription: "(CETP)",
      active: "active1",
      backgroundvalue: background5,
    },
    {
      Heading: "SUNDAR INDUSTRY",
      Title: "The future of BOMSIE",
      Discription: "2022",
      active: "active2",
      backgroundvalue: background3,
    },
    {
      Heading: "SUNDAR INDUSTRY",
      Title: "Group photo",
      Discription: "BOMSIE",
      active: "active3",
      backgroundvalue: background4,
    },
    // {
    //   Heading: "SUNDAR INDUSTRY",
    //   Title: "Group photo",
    //   Discription: "BOMSIE",
    //   active: "active3",
    //   backgroundvalue: background4,
    // },
    // {
    //   Heading: "SUNDAR INDUSTRY Estate",
    //   Title: "SUNDAR PICTURE",
    //   Discription: "SUNDAR",
    //   active: "active3",
    //   backgroundvalue: background5,
    // },
  ];
  function next() {
    setChange(count + 1);
    if (count > 1) {
      setChange(0);
    }
  }
  function previous() {
    setChange(count - 1);
    if (count < 1) {
      setChange(2);
    }
  }
  const background = array[count].backgroundvalue;
  const thisactive = array[count].active;
  return (
    <>
      <div
        style={{ backgroundImage: `url(${background})` }}
        className="sliderr position-relative d-flex justify-content-center align-items-center"
      >
        <div className="container-fluid bg-transparent h-100 position-absolute m-0 p-0 overflow-hidden d-flex justify-content-center align-items-center">
          {/* <video
            className="position-absolute d-flex justify-content-center align-items-center"
            autoPlay
            loop
            muted
            src={background}
          ></video> */}
          <div className="position-absolute overlay opacity-50 h-100 w-100 position-absolute bg-dark d-flex justify-content-center align-items-center"></div>
        </div>

        <div className="position-absolute top-0 container-fluid bg-transparent p-3 mt-2">
          <div>
            <Toolbar style="text-white" />
          </div>
        </div>
        <div className="text-center text-white position-absolute">
          <h1 id="colorslider" className={thisactive}>
            {array[count].Heading}
          </h1>
          <h1 className={thisactive} style={{ animationDelay: "0.28s" }}>
            {array[count].Title}
          </h1>
          <h1
            id="fontslider"
            className={thisactive}
            style={{ animationDelay: "0.62s" }}
          >
            {array[count].Discription}
          </h1>
          <div className={thisactive} style={{ animationDelay: "1.08s" }}>
            <button
              style={{ borderRadius: "50px" }}
              className="btn bg-transparent px-3 py-1 mx-1 text-white border-white"
            >
              Learn More <FaAngleRight />
            </button>
            <button
              style={{ borderRadius: "50px" }}
              className="btn bg-transparent px-3 py-1 mx-1 text-white border-white"
            >
              Buy now <FaAngleRight />
            </button>
          </div>
        </div>
        <button
          className="btn anglebtn bg-transparent position-absolute start-0"
          onClick={previous}
        >
          <FaAngleLeft />
        </button>
        <button
          className="btn anglebtn bg-transparent position-absolute end-0"
          onClick={next}
        >
          <FaAngleRight />
        </button>
        <div className="container-fluid bg-transparent d-flex justify-content-center py-4 position-absolute bottom-0 mb-4">
          <div className="input-main">
            <div className="row">
              <div className="col position-relative d-flex align-items-start flex-column justify-content-center">
                <p className="ml">Search</p>
                <input
                  placeholder="Click here to see all tenders"
                  className="input ml"
                  type="text"
                />
                <div className="line"></div>
              </div>
              <div className="col col2 position-relative d-flex align-items-start flex-column justify-content-center">
                <p>Location in</p>
                <input
                  placeholder="Sundar-Raiwind Road, Lahore"
                  className="input"
                  type="text"
                />
                <button className="svgg position-absolute ">
                  <BiSearch className="text-muted mx-2 fs-2 pt-1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
